<div class="grid">
  <div class="content-topbar">
    <div class="col-12 pb-0 pt-2">
      <button
        pButton
        *ngIf="userService.canEdit()"
        pRipple
        [disabled]="(degradedModeService.isDegradedMode() | async) ?? false"
        type="button"
        style="width: auto"
        icon="pi pi-save"
        class="p-button-success mr-2 mb-2 humensis-green"
        (click)="saveAllChanges()"
      >
        <span style="margin-left: 4px">Sauvegarder</span>
      </button>
      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-file-excel"
        (click)="exportOuvrageComplet()"
        class="p-button-success mb-2 mr-2"
        pTooltip="XLS"
        tooltipPosition="bottom"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-file"
        (click)="exportIsi()"
        class="p-button-success mb-2 mr-2"
        pTooltip="ISI"
        tooltipPosition="bottom"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-file"
        (click)="exportInov()"
        class="p-button-success mb-2 mr-2"
        pTooltip="IINOV"
        tooltipPosition="bottom"
      ></button>
      <app-dispatch-max [ouvrageId]="ouvrageId"></app-dispatch-max>
    </div>
  </div>
  <div class="fix-navbar-height"></div>
</div>

<div class="grid">
  <div class="col-12 md:col-12">
    <app-resume-ouvrage
      [ouvrageId]="ouvrageId"
      (onDataChange)="updateProjet($event)"
      (onStatutChange)="reloadPages()"
    ></app-resume-ouvrage>
  </div>
</div>

<div>
  <p-tabView orientation="left">
    <p-tabPanel header="Pages d'atterrissage">
      <div class="loading" *ngIf="!this.onLoadingPageAtterrissageDone">
        <p class="mb-2">Chargement en cours ...</p>
        <p-progressBar
          mode="indeterminate"
          [style]="{ height: '6px' }"
        ></p-progressBar>
      </div>
      <div class="col-12 md:col-12">
        <app-pages-atterissage
          [ouvrageId]="ouvrageId"
          [statutOuvrage]="statutOuvrage"
          (onLoadingDone)="this.onLoadingPageAtterrissageDone = true"
          (onDataChange)="updatePagesChanges($event)"
          (onPageDelete)="removePage($event)"
        ></app-pages-atterissage>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Ressources Numériques">
      <ng-template pTemplate="content">
        <div class="loading" *ngIf="!this.onLoadingRessourcesNumeriquesDone">
          <p class="mb-2">Chargement en cours ...</p>
          <p-progressBar
            mode="indeterminate"
            [style]="{ height: '6px' }"
          ></p-progressBar>
        </div>
        <div class="col-12 md:col-12">
          <app-ressources-numeriques
            [ouvrageId]="ouvrageId"
            [statutOuvrage]="statutOuvrage"
            [codeOuvrage]="ouvrage?.CodeProjet"
            [isReprise]="ouvrage?.is_reprise"
            [dateCreationOuvrage]="ouvrage?.creationDate"
            (onLoadingDone)="this.onLoadingRessourcesNumeriquesDone = true"
            (onDataChange)="updateRNChanges($event)"
          >
          </app-ressources-numeriques>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>

<p-toast key="update"></p-toast>
